import { useEffect, useRef } from 'react';
import * as React from 'react';
import {AddOrEditBlockProps} from "./ToolDrawerGrid/AddOrEditBlock";

const EditForm: React.FC<AddOrEditBlockProps> = props => {
    const containerRef = useRef<HTMLDivElement | null>(null);
    const displaySettings = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (containerRef.current && displaySettings.current) {
            containerRef.current.scrollTop = props.showBlockDisplaySettings ? displaySettings.current.offsetTop : 0;
        }
    }, [props.showBlockDisplaySettings]);

    return <div className={`sb-block-container ${props.className || ""}`} ref={containerRef}>
        <p style={{marginBottom: "1em", padding: "0 1rem"}}>
            {props.description}
        </p>
        <div id="edit-block-form"
             data-help-video-url="https://youtu.be/1j-yYDTRfZ0"
             className="form-horizontal" >
            <div className="sb-blockScroller" ref={displaySettings}>
                {props.children}
            </div>
        </div>
    </div>
}

export default EditForm;
